/**
 * Clears dynamic (user-specific) PWA caches and notifies the service worker.
 *
 * Called on logout to ensure no user data remains in the browser cache.
 */
export async function clearDynamicCaches(): Promise<void> {
  if (typeof caches === 'undefined') {
    return;
  }

  const cacheNames = await caches.keys();
  await Promise.all(
    cacheNames.filter((name) => name.startsWith('api-cache')).map((name) => caches.delete(name)),
  );

  if (navigator.serviceWorker?.controller) {
    navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_DYNAMIC_CACHES' });
  }
}
